import React from 'react';
import { get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// local dependencies
import { CallManagementListsWidgetService } from 'services/callManagementListsWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { callManagementListsWidget as CallManagementListsWidgetView } from 'ui/views/widgets/callManagementListsWidget';
import { getRedirectionRoute } from 'resolvers/callStateEntities';
import { REDUCER } from 'constants/entity-names';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallManagementListsWidget } from 'ui/containers/CallManagementListsWidget';
 *
 * // render
 * <CallManagementListsWidget propName='propValue'/>
 */
class _CallManagementListsWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.callManagementListsWidgetService = new CallManagementListsWidgetService();

        // get the path for redirection in case call is ongoing, else start data fetch
        if( ! isEmpty( get( props, 'callState', {} ) ) ) {
            const redirectionPath = getRedirectionRoute( props.callState );

            if( ! isEmpty( redirectionPath ) ) {
                props.history.push( redirectionPath );
            }
        } else {
            this.fetchComponentData();
        }
    }

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'CallManagementListsWidget.fetchComponentData()' );

        // cancel ongoing request
        this.callManagementListsWidgetService.cancel();

        // get status and service data
        const { status, data } = await this.callManagementListsWidgetService.fetchWidgets( {
            url: this.props.widget.url,
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.callManagementListsWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallManagementListsWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                widgets={ get( this.state, 'componentData.widgets', [] ) }
            />
        );
    }
}

// set display name
_CallManagementListsWidget.displayName = '_CallManagementListsWidget';

// set default props
_CallManagementListsWidget.defaultProps = {
    widget: {}, // widget configuration
};

// prop types
_CallManagementListsWidget.propTypes = {};


/*************************************************/

// map state to props
const mapStateToProps = ( state ) => {
    return {
        callState: state[ REDUCER.CALL_STATE ],
        appContext: state[ REDUCER.APP_CONTEXT ],
    };
};

// return component with acccess to Redux store
export const CallManagementListsWidget = withRouter( connect( mapStateToProps, null )( _CallManagementListsWidget ) );
